import React from 'react';
import type { ComponentProps, ReactNode } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { Row, StyledLink } from './styled';

type ArrowLinkProps = ComponentProps<typeof StyledLink> & {
  children: ReactNode;
  labelEnd?: ReactNode;
};

export const ArrowLink = ({ children, labelEnd, ...props }: ArrowLinkProps) => (
  <StyledLink {...props}>
    <Row>
      <Typography variant="copyOne">{children}</Typography>
      <Box style={styles.endContent}>
        {labelEnd}
        <Icon variant="next" ml="$1" width="4" {...hiddenAccessibilityPlatformProps} />
      </Box>
    </Row>
  </StyledLink>
);

const styles = StyleSheet.create({ endContent: { alignItems: 'center', flexDirection: 'row' } });
